import {ReportConfig} from "../app/entity/report";
import {AuthConfig} from "@auth0/auth0-angular";

//CONFIGS FOR REPORTS
let report_SCFS: ReportConfig = { 
   groupId: '1a5fcd47-1f34-474c-aea3-961f61fd40c3', 
   name: "Supply Chain Food Service Abnahme"
  }

// Remove after Debbuging
let report_eInvoicing_Onboardings_Debug: ReportConfig = {
  groupId: 'a2b94803-6fa9-4f46-a04c-ed5f11495c41',
  name: "e-Invoicing Onboardings"
}
    
// GENERAL PROPERTIES FOR AUTH0 (NO NEED TO CHANGE)
const authConfig: AuthConfig = {
  domain: 'https://int-identity.markant.com',
  clientId: 'Jt148OI2T0sSCoXYXOeRZCsgYSZmg07F',
  authorizationParams: {
    redirect_uri: window.location.origin
  },
  httpInterceptor: {allowedList: ['http://localhost:8080/*', 'https://pbie-authdev.markant.services/*']}
}

export const environment = {
  // GENERAL PROPERTIES (NO NEED TO CHANGE)
  production: false,
  forbiddenErrorUrl: 'https://markant-net.markant.services/error/forbidden',

  // PROPERTIES TO EDIT (SPECIFIC FOR REPORT APP)
  reports: new Map<string, ReportConfig>([ //use arrow fonction to force angular 
    ["supply-chain-food-services", report_SCFS],
    ["e-invoicing-onboardings-dev", report_eInvoicing_Onboardings_Debug]
  ]),
  groupsClaimName: 'markant_groups',

  authConfig,
   // authorizerServiceUrl: 'http://localhost:8080/'
   authorizerServiceUrl: 'https://pbie-authdev.markant.services/' //TO CHANGE
};

// optional debug
console.warn(
  'ENVIRONMENT DEV LOADED',
  Array.from(environment.reports.keys())
);
